<template>
    <div class="scope-exam-topic main-container">
        <div class="box-shadow-small border-radius container" v-if="resData">
            <div class="exam-topic-header">
                <h1>{{resData.paperName}}</h1>
                <p>{{resData.examDuration}}</p>
                <h2>{{resData.examSummary}}。</h2>
            </div>
            <div class="exam-topic-body">
                <div class="box-shadow-small background-white border-radius exam-topic-item" v-if="resData.singleChoice.length">
                    <h3>{{num2Chinese(singleSelectIndex)}}、{{resData.titles[singleSelectIndex].title}}</h3>
                    <p><span v-if="subTitle(singleSelectIndex)">({{subTitle(singleSelectIndex)}} )</span></p>
                    <div class="detail">
                        <div v-for="(item, index) in resData.singleChoice" :key="index" class="mt-20">
                            <h4>{{index+1}}. <span v-html="item.content" class="ques-txt"></span> <span style="font-weight: bold">（<span :class="answerColor(singleChoiceData, index)" :key="index">{{singleChoiceData.user[index]}}</span>）</span></h4>
                            <ul class="exam-topic-options">
                                <li v-for="(option, opIndex) in item.options" :key="opIndex">{{num2letter(opIndex+1)}}.{{option.content}}</li>
                            </ul>
                            <p class="system-answer">正确答案：<span>{{resData.correctAnswers[item.id] ? resData.correctAnswers[item.id][0].content : '-'}}</span></p>
                            <p class="system-answer" v-if="item.analysis">答案分析：<span v-html="item.analysis"></span></p>
                        </div>
                    </div>
                    <div class="score-line">
                    </div>
                </div>
                <div class="box-shadow-small background-white border-radius exam-topic-item" v-if="resData.multipleChoice.length">
                    <h3>{{num2Chinese(multiSelectIndex)}}、{{resData.titles[multiSelectIndex].title}} </h3>
                    <p><span v-if="subTitle(multiSelectIndex)">({{subTitle(multiSelectIndex)}} )</span></p>
                    <div class="detail">
                        <div v-for="(item, index) in resData.multipleChoice" :key="index" class="mt-20">
                            <h4>{{index+1}}.<span v-html="item.content" class="ques-txt"></span> <span style="font-weight: bold">（<span :class="answerColor(singleChoiceData, index)" :key="index">{{multipleChoiceData.user[index]}}</span>）</span></h4>
                            <ul class="exam-topic-options">
                                <li v-for="(option, opIndex) in item.options" :key="opIndex">{{num2letter(opIndex+1)}}.{{option.content}}</li>
                            </ul>
                            <p class="system-answer">正确答案：<span>{{resData.correctAnswers[item.id] ? resData.correctAnswers[item.id][0].content : '-'}}</span></p>
                            <p class="system-answer" v-if="item.analysis">答案分析：<span v-html="item.analysis"></span></p>
                        </div>
                    </div>
                    <div class="score-line">
                    </div>
                </div>
                <div class="box-shadow-small background-white border-radius exam-topic-item" v-if="resData.fillTheBlank.length">
                    <h3>{{num2Chinese(fillBlackIndex)}}、{{resData.titles[fillBlackIndex].title}}</h3>
                    <p><span v-if="subTitle(fillBlackIndex)">({{subTitle(fillBlackIndex)}} )</span></p>
                    <div>
                        <el-row v-for="(item, index) in resData.fillTheBlank" :key="index">
                            <el-col :span="22">
                                <h4>{{index+1}}. <span v-html="getFillBlankAndAns(item)"></span></h4>
                                <p class="system-answer">正确答案：<span v-for="(ans, indexj) in resData.correctAnswers[item.id]" :key="index+indexj"><span>{{ans.content}}</span>
                                    <span class="color-info ml-5 mr-5" v-if="indexj < resData.correctAnswers[item.id].length-1">|</span></span></p>
                                <p class="system-answer" v-if="item.analysis">答案分析：<span v-html="item.analysis"></span></p>
                            </el-col>
                            <el-col :span="2">
                            </el-col>
                        </el-row>
                    </div>
                    <div class="score-line">
                    </div>
                </div>
                <div class="box-shadow-small background-white border-radius exam-topic-item" v-if="resData.questionAnswer.length">
                    <h3>{{num2Chinese(simpleAnswerIndex)}}、{{resData.titles[simpleAnswerIndex].title}} </h3>
                    <p><span v-if="subTitle(simpleAnswerIndex)">({{subTitle(simpleAnswerIndex)}} )</span></p>
                    <div>
                        <el-row v-for="(item, index) in resData.questionAnswer" :key="index">
                            <el-col :span="22">
                                <h4>{{index+1}}.<span v-html="item.content" class="ques-txt"></span></h4>
                                <div>
                                    <label class="exam-topic-blank-label">答案：</label>
                                    <div class="exam-topic-blank block answer-txt">{{resData.answers[item.id] ? resData.answers[item.id][0].content : '-'}}
                                    </div>
                                </div>
                                <p class="system-answer">答案分析：<span v-html="item.analysis"></span></p>
                            </el-col>
                            <el-col :span="2">
                            </el-col>
                        </el-row>
                    </div>
                    <div class="score-line">
                    </div>
                </div>
            </div>
            <div class="text-center mt-20 mb-20">
                <el-button type="primary" plain="" @click="$win.close">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import _ from 'underscore'
    export default {
        data () {
            return {
                resData: null,
                allScore: '-',
                totalFillText: 0,
                totalSimpleAnswer: 0,
                fillTextScore: {},
                simpleAnserScore: {},
                singleChoiceMode: '简单',
                multiChoiceMode: '简单'
            }
        },
        computed: {
            singleSelectIndex () {
                return 0
            },
            multiSelectIndex () {
                return !!this.resData.singleChoice.length + 0
            },
            fillBlackIndex () {
                return !!this.resData.multipleChoice.length + !!this.resData.singleChoice.length + 0
            },
            simpleAnswerIndex () {
                return !!this.resData.fillTheBlank.length + !!this.resData.multipleChoice.length + !!this.resData.singleChoice.length + 0
            },
            singleChoiceData () {
                let result = {
                    user: [],
                    system: []
                }
                if (this.resData && this.resData.singleChoice) {
                    let correctAnswer = this.resData.correctAnswers,
                        userAnswer = this.resData.answers
                    this.resData.singleChoice.forEach(item => {
                        let user = userAnswer[item.id] || [],
                            correct = correctAnswer[item.id] || [],
                            userAnsId = user.map(u => +u.content),
                            correctAnsId = correct.map(c => c.id),
                            allOptionsId = item.options.map(i => i.id),
                            userAnsIndex = allOptionsId.indexOf(userAnsId[0]),
                            correntAnsIndex = allOptionsId.indexOf(correctAnsId[0])
                        result.user.push(userAnsIndex < 0 ? '-' : this.num2letter(userAnsIndex + 1))
                        result.system.push(correntAnsIndex < 0 ? '-' : this.num2letter(correntAnsIndex + 1))
                    })
                }
                return result
            },
            multipleChoiceData () {
                let result = {
                    user: [],
                    system: []
                }
                if (this.resData && this.resData.multipleChoice) {
                    let userAnswer = this.resData.answers,
                        correctAnswer = this.resData.correctAnswers
                    this.resData.multipleChoice.forEach(item => {
                        let user = userAnswer[item.id] || [],
                            correct = correctAnswer[item.id] || [],
                            userAnsId = user.map(u => +u.content),
                            correctAnsId = correct.map(c => c.id),
                            allOptionsId = item.options.map(i => i.id),
                            userAnsLetter = [],
                            correctAnsLetter = []
                        userAnsId.forEach(oneUserAnsId => {
                            let userAnsIndex = allOptionsId.indexOf(oneUserAnsId)
                            userAnsLetter.push(userAnsIndex < 0 ? '-' : this.num2letter(userAnsIndex + 1))
                        })
                        result.user.push(userAnsLetter.sort().join(''))

                        correctAnsId.forEach(oneCorrectAnsId => {
                            let correctAnsIndex = allOptionsId.indexOf(oneCorrectAnsId)
                            correctAnsLetter.push(correctAnsIndex < 0 ? '-' : this.num2letter(correctAnsIndex + 1))
                        })
                        result.system.push(correctAnsLetter.sort().join(''))
                    })
                }
                return result
            }
        },
        methods: {
            num2letter (num) {
                let letter = num <= 26 ? String.fromCharCode(num + 64) : convert(~~((num - 1) / 26)) + convert(num % 26 || 26)
                return letter
            },
            answerColor (choice, index) {
                if (choice.user[index] === choice.system[index]) {
                    return 'color-primary'
                } else {
                    return 'color-danger'
                }
            },
            getFillBlankAndAns (item) {
                let conunter = 0,
                    userAns = this.resData.answers[item.id] || [],
                    resultContent = item.content.replace(/\[!--fill_the_blank--\]/ig, () => {
                        if (conunter < userAns.length) {
                            let userContent = _.escape(userAns[conunter++].content)
                            return `<span class="exam-topic-blank">${userContent}</span>`
                        } else {
                            return `<span class="exam-topic-blank"></span>`
                        }
                    })
                return resultContent
            },
            num2Chinese (index) {
                return ['一', '二', '三', '四', '五'][index]
            },
            subTitle (type) {
                return this.resData.titles[type].titleSub
            }
        },
        created () {
            let rpId = this.$route.query.resumePositionId
            let url = '/arrangeExam/previewPaperAndAns.api'
            let params = rpId ? {
                paperId: this.$route.params.id,
                resumePositionId: rpId,
                examId: this.$route.query.examId
            } : {
                paperId: this.$route.params.id
            }
            this.$axios.post(url, params).then(res => {
                this.resData = res.result.paper
                this.resData.fillTheBlank.forEach(item => {
                    this.fillTextScore[item.id] = this.resData.answers[item.id] ? this.resData.answers[item.id][0].score : 0
                    this.totalFillText += this.fillTextScore[item.id]
                })
                _.keys(this.resData.questionAnswer).length && this.resData.questionAnswer.forEach(item => {
                    this.simpleAnserScore[item.id] = this.resData.answers[item.id] ? this.resData.answers[item.id][0].score : 0
                })
                this.allScore = parseInt(0 + this.resData.allScore)
            })
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .scope-exam-topic {
        .ques-txt,.answer-txt{
            white-space: pre-line;
        }
        .answer-txt{
            padding: 0 5px;
        }
        .container {
            padding : 30px;
        }
        .exam-topic-header {
            text-align : center;
            h1 {
                font-size : 24px;
            }
            p {
                margin : 15px 0 20px;
                color  : $text-color-third;
            }
            h2 {
                font-size  : 18px;
                text-align : left;
            }
        }
        .exam-topic-item {
            margin-top : 30px;
            padding    : 0 30px;
            border-top : 1px dashed $color-primary;
            position   : relative;

            > h3 {
                position    : absolute;
                top         : -15px;
                left        : 50%;
                margin-left : -70px;
                width       : 140px;
                text-align  : center;
                background  : #fff;
                font-size   : 18px;
                color       : $color-primary;
            }
            > p {
                margin     : 20px 0;
                color      : $text-color-third;
                text-align : center;
            }
            > h4 {
                font-weight   : bold;
                margin-bottom : 10px;
            }
            .exam-topic-options {
                > li {
                    line-height : 30px;
                    &:before {
                        content        : '';
                        display        : inline-block;
                        width          : 18px;
                        height         : 18px;
                        border-radius  : 50%;
                        border         : 1px solid #c1cbd9;
                        vertical-align : middle;
                        margin-right   : 10px;
                    }
                }
                &.multi {
                    > li {
                        &:before {
                            content        : '';
                            display        : inline-block;
                            width          : 18px;
                            height         : 18px;
                            border-radius  : $border-radius;
                            border         : 1px solid #c1cbd9;
                            vertical-align : middle;
                            margin-right   : 10px;
                        }
                    }
                }
            }
            .exam-topic-blank-label {
                float : left;
                + .exam-topic-blank {
                    overflow : hidden;
                }
            }
            .exam-topic-blank {
                display        : inline-block;
                margin         : 0 5px;
                border-radius  : $border-radius;
                border         : 1px solid #c1cbd9;
                min-height         : 34px;
                line-height    : 34px;
                min-width          : 200px;
                vertical-align : middle;
                &.block {
                    display : block;
                    min-height  : 100px;
                    width   : inherit;
                    &:before {
                        margin-left : 10px;
                        margin-top  : 5px;
                        display     : inline-block;
                        content     : '';
                        color       : $text-color-third;
                    }
                    &.answer-txt{
                        &:before{
                            display: none;
                        }
                    }
                }
            }
        }
        .system-answer{
            color: #999;
            line-height: 24px;
            padding: 0px 0 15px;
            white-space: pre-line;
            text-align: left !important;
        }
    }
</style>


// WEBPACK FOOTER //
// examTopic.vue?574ef0bd